import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { CollectionListUniDriver } from '../CollectionList/CollectionList.uni.driver';
import { LoaderUniDriver } from '@wix/design-system/dist/testkit/unidriver';

export function InfiniteScrollCollectionListUniDriver(
  base: UniDriver,
  body: UniDriver,
) {
  const list = CollectionListUniDriver(base, body);

  const loaderDriver = LoaderUniDriver(
    base.$(`[data-hook="infinite-scroll-loader"]`),
    body,
  );

  return {
    ...list,
    loaderDriver,
  };
}
